<template>
    <div class="text-left bg-gray-800 rounded-md shadow-lg px-3 py-2 flex items-start">
        <div class="pt-1 mr-3">
            <div class="text-gray-200 uppercase text-xxs font-semibold leading-none tracking-wide">
                Filter
            </div>

            <i aria-hidden="true" class="material-icons text-gray-200 text-3xl block" style="margin-left: 2px;">filter_list</i>
        </div>

        <div class="flex flex-col flex-none mb-1 mx-0">
            <label for="favorites"
                class="text-xs text-gray-500 font-semibold mb-1"
            >
                Faves
            </label>

            <div class="w-full h-6 -mt-1 mb-0">
                <button type="button"
                    class="border-transparent bg-transparent text-gray-500 text-xs focus:outline-none focus:text-red-500 hover:bg-transparent hover:text-red-500 py-0 pr-2 pl-0"
                    @click="toggleFavorites"
                >
                    <i aria-hidden="true" class="material-icons text-4xl block">
                        {{ limit_to_favorites ? 'favorite' : 'favorite_border' }}
                    </i>
                </button>
            </div>
        </div>

        <div class="flex-1 mb-1 mx-2">
            <label for="tags"
                class="flex items-center text-xs text-gray-500 font-semibold mb-1"
            >
                <div v-if="selected_tag_id"
                    class=""
                    @click="selected_tag_id = null"
                >
                    <i class="block cursor-pointer text-red-400 hover:text-white material-icons mr-1 text-base">
                        clear
                    </i>
                </div>

                Tags
            </label>

            <div class="dropdown-wrapper w-full mb-0">
                <select v-model="selected_tag_id"
                    id="tags"
                    name="tags"
                    class="dropdown-select dropdown-select-sm bg-gray-200"
                >
                    <option :value="null"></option>
                    <option v-for="tag in tags"
                        :value="tag.id"
                    >
                        {{ tag.name }}
                    </option>
                </select>

                <div class="dropdown-arrow">
                    <svg class="fill-current text-black h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
            </div>
        </div>

        <div class="flex-1 mb-1 mx-2">
            <label for="authors"
                class="flex items-center text-xs text-gray-500 font-semibold mb-1"
            >
                <div v-if="selected_author_id"
                    class=""
                    @click="selected_author_id = null"
                >
                    <i class="block cursor-pointer text-red-400 hover:text-white material-icons mr-1 text-base">
                        clear
                    </i>
                </div>

                Authors
            </label>

            <div class="dropdown-wrapper w-full mb-0">
                <select v-model="selected_author_id"
                    id="authors"
                    name="authors"
                    class="dropdown-select dropdown-select-sm bg-gray-200"
                >
                    <option :value="null"></option>
                    <option v-for="author in authors"
                        :value="author.id"
                    >
                        {{ author.name }}
                    </option>
                </select>

                <div class="dropdown-arrow">
                    <svg class="fill-current text-black h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
            </div>
        </div>

        <div class="flex-1 mb-1 mx-2">
            <label for="psych_models"
                class="flex items-center text-xs text-gray-500 font-semibold mb-1"
            >
                <div v-if="selected_psych_model_id"
                    class=""
                    @click="selected_psych_model_id = null"
                >
                    <i class="block cursor-pointer text-red-400 hover:text-white material-icons mr-1 text-base">
                        clear
                    </i>
                </div>

                Psych Models
            </label>

            <div class="dropdown-wrapper w-full mb-0">
                <select v-model="selected_psych_model_id"
                    id="psych_models"
                    name="psych_models"
                    class="dropdown-select dropdown-select-sm bg-gray-200"
                >
                    <option :value="null"></option>
                    <option v-for="psych_model in psych_models"
                        :value="psych_model.id"
                    >
                        {{ psych_model.name }}
                    </option>
                </select>

                <div class="dropdown-arrow">
                    <svg class="fill-current text-black h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
            </div>
        </div>

        <div class="flex-1 mb-1 mx-2">
            <label for="annotation_status"
                class="flex items-center text-xs text-gray-500 font-semibold mb-1"
            >
                <div v-if="annotation_status !== null"
                    @click="annotation_status = null"
                >
                    <i class="block cursor-pointer text-red-400 hover:text-white material-icons mr-1 text-base">
                        clear
                    </i>
                </div>

                Polished
            </label>

            <div class="dropdown-wrapper w-full mb-0">
                <select v-model="annotation_status"
                    id="annotation_status"
                    name="annotation_status"
                    class="dropdown-select dropdown-select-sm bg-gray-200"
                >
                    <option :value="null"></option>
                    <option :value="true">Polished Chapters</option>
                    <option :value="false">Unpolished Chapters</option>
                </select>

                <div class="dropdown-arrow">
                    <svg class="fill-current text-black h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sections: {},
        authors: {},
        psych_models: {},
        tags: {},
        self_id: {},
        clicked_author_id: {},
        clicked_psych_model_id: {},
        clicked_tag_id: {},
    },

    data() {
        return {
            selected_author_id: null,
            selected_psych_model_id: null,
            selected_tag_id: null,
            annotation_status: null,
            limit_to_favorites: false,
        }
    },

    computed: {
        filtered_authors() {
            return this.selected_author_id
                && this.containsId(this.selected_author_id, this.authors)
                    ? this.sections.filter(section => {
                        return section.authors.some(author => author.id == this.selected_author_id)
                    })
                    : this.sections;
        },
        filtered_psych_models() {
            return this.selected_psych_model_id
                && this.containsId(this.selected_psych_model_id, this.psych_models)
                    ? this.sections.filter(section => {
                        return section.psych_models.some(model => model.id == this.selected_psych_model_id)
                    })
                    : this.sections;
        },
        filtered_tags() {
            return this.selected_tag_id
                && this.containsId(this.selected_tag_id, this.tags)
                    ? this.sections.filter(section => {
                        return section.tags.some(tag => tag.id == this.selected_tag_id)
                    })
                    : this.sections;
        },
        filtered_favorites() {
            return this.limit_to_favorites
                ? this.sections.filter(section => {
                    return section.is_favorite == true;
                })
                : this.sections;
        },
        filtered_annotation_status() {
            return this.annotation_status !== null
                ? this.sections.filter(section => {
                    return Boolean(section.annotations_count) == Boolean(this.annotation_status);
                })
                : this.sections;
        },
        filtered_sections() {
            return this.filtered_authors
                .filter(section => this.filtered_psych_models.includes(section))
                .filter(section => this.filtered_tags.includes(section))
                .filter(section => this.filtered_favorites.includes(section))
                .filter(section => this.filtered_annotation_status.includes(section));
        }
    },

    methods: {
        toggleFavorites() {
            this.limit_to_favorites = ! this.limit_to_favorites;
        },
        containsId(id, list) {
            return list.some(item => item.id == id);
        },
    },

    created() {
        const with_annotations =
            new URLSearchParams(window.location.search).get('with-annotations');

        if (with_annotations == 'true') {
            this.annotation_status = true;
        } else if (with_annotations == 'false') {
            this.annotation_status = false;
        }

        this.selected_tag_id = new URLSearchParams(window.location.search).get('tag');
        this.selected_author_id = new URLSearchParams(window.location.search).get('author');
        this.selected_psych_model_id = new URLSearchParams(window.location.search).get('psych-model');
    },

    watch: {
        filtered_sections: {
            handler(val) {
                this.$emit('filtered', val)
            },
            immediate: true,
        },
        clicked_author_id: {
            handler(val) {
                this.selected_author_id = val;
            },
            immediate: true,
        },
        clicked_psych_model_id: {
            handler(val) {
                this.selected_psych_model_id = val;
            },
            immediate: true,
        },
        clicked_tag_id: {
            handler(val) {
                this.selected_tag_id = val;
            },
            immediate: true,
        },
    },
}
</script>

